import {UseFieldArrayRemove} from "react-hook-form";
import {VariantOptionListItemOptionNameFormField} from "./option-name";
import {StyledVariantOptionListItemWrapper} from "./styles";
import {VariantOptionListItemOptionPriceTypeFormField} from "./option-price-type";
import {Space} from "antd";
import {VariantOptionListItemOptionCurrencyListFormField} from "./option-currency-list";
import {ProductPricingFormFieldsType} from "../../pricing/types";
import {ProductVariantsFormFieldsProps} from "../types";

type VariantOptionListItemProps = {
  optionIndex: number;
  variantIndex: number;
  removeVariantOptionItem: UseFieldArrayRemove;
  productCurrencies: ProductPricingFormFieldsType["currencies"];
  productSelectedPriceType: "paid" | "free";
  hydratedRef: ProductVariantsFormFieldsProps["hydratedRef"];
};

export function VariantOptionListItem({
  optionIndex,
  variantIndex,
  removeVariantOptionItem,
  productCurrencies,
  productSelectedPriceType,
  hydratedRef,
}: VariantOptionListItemProps) {
  const id = `variantListItemOptionListItem-${optionIndex + 1}`;
  const label = `Option ${optionIndex + 1}`;
  return (
    <StyledVariantOptionListItemWrapper>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <VariantOptionListItemOptionNameFormField
          optionIndex={optionIndex}
          label={label}
          variantIndex={variantIndex}
          id={id + "-name"}
          removeVariantOptionItem={removeVariantOptionItem}
        />
        <VariantOptionListItemOptionPriceTypeFormField
          optionIndex={optionIndex}
          variantIndex={variantIndex}
          id={id + "-priceType"}
        />
        <VariantOptionListItemOptionCurrencyListFormField
          label="Price"
          optionIndex={optionIndex}
          variantIndex={variantIndex}
          productCurrencies={productCurrencies}
          productSelectedPriceType={productSelectedPriceType}
          hydratedRef={hydratedRef}
        />
      </Space>
    </StyledVariantOptionListItemWrapper>
  );
}
